"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeCancelable = exports.ActionAwaiter = void 0;
const promise_container_1 = require("./promise-container");
Object.defineProperty(exports, "ActionAwaiter", { enumerable: true, get: function () { return promise_container_1.ActionAwaiter; } });
const cancelable_promise_1 = require("./cancelable-promise");
Object.defineProperty(exports, "makeCancelable", { enumerable: true, get: function () { return cancelable_promise_1.makeCancelable; } });
